module.exports = "https://static.wagwalking.com/_next/static/images/wag_app_image-979d66eac71974e314daa478ed78d5fa.png";